import { defineMessages } from "react-intl";
const localized = defineMessages({
  label: {
    id: "multiStepFilterDatePicker_label",
    defaultMessage: "Date Range"
  },
  placeholder: {
    id: "DateRangePicker_Placeholder",
    defaultMessage: "Select Date Range"
  },
  month: {
    id: "multiStepFilterDatePicker_month",
    defaultMessage: "Month"
  },
  year: {
    id: "multiStepFilterDatePicker_year",
    defaultMessage: "Year"
  },
  reportInputTooltipMessage: {
    id: "DateRangeFilter_reportInputTooltipMessage",
    defaultMessage: "Data older than {range} is not available. Reports can display up to the past {range} only."
  }
});
export {
  localized
};
//# sourceMappingURL=localized.js.map
